import axios from "axios"

export const fetchTemplatesByDevice = async (deviceId) => {
  let titles = {}

  const result = await axios.get(`/templates/${deviceId}`)

  if (
    result?.data?.templates
    && result?.data?.templates.length > 0
  ) {
    result.data.templates.forEach((item) => {
      titles[item.template_id] = item.title
    })
  }

  return titles
}